<div id="SavedCard" *ngIf="!(isCardShow || isBankInfoShow || isKeypadShow || isEditWalletShow)">
  <div *ngIf="cards === undefined">
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
  </div>
  <div *ngIf="cards?.length == 0" class="header-plan-msg">
    <div class="message">
        You do not have any saved wallets yet
    </div>
  </div>
  <div *ngIf="cards?.length > 0">
    <div class="header">Saved Payment Methods</div>
    <div class="scroll-div">
      <div class="row">
        <div class="col-md-6" *ngFor="let card of cards; let i = index">
          <div class="add-card-button added-detail show-details" *ngIf="!card.isEditing" >
            <img *ngIf="card.accountNumber == undefined" src="ui/assets/img/CreditDebit_Action.svg" class="cc-ach-side-icons left" />
            <img *ngIf="card.accountNumber != undefined" src="ui/assets/img/Bank_Active.svg" class="cc-ach-side-icons left" />
            <div class="card-name">
                <span>{{card.nickname | truncate : 15}}</span>
            </div>
            <div class="card-info" *ngIf="card.accountNumber == undefined">
              Credit
              Card<br>
              {{card.nameOnAccount | truncate : 25}}<br>
              {{getWalletAccountNumbers(card) | truncate : 25}}<br>
              {{card.ccNumber}}<br>
              {{card.ccExp}}<br>
            </div>
            <div class="card-info" *ngIf="card.accountNumber != undefined">
              {{card.achBusinessAccount ? 'Business' : ''}}
              Checking
              Account<br>
              {{card.nameOnAccount | truncate : 25}}<br>
              {{getWalletAccountNumbers(card) | truncate : 25}}<br>
              {{card.accountNumber}}<br>
              {{card.routingNumber}}
            </div>
            <!-- Edit Icon -->
            <a class='btn' type="button">
              <i class="fa fa-edit edit-icon" (click)="toggleEditWalletShow(card)" placement="bottom left auto"
                container="body" ngbTooltip="Edit Wallet"></i>
            </a>
            <!-- Delete Icon -->
            <a class='btn' type="button">
              <i class="fas fa-trash-alt delete-icon" (click)="onDelete(card)" placement="bottom left auto"
                container="body" ngbTooltip="Delete Wallet"></i>
            </a>
            
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="clearfix"></div>
  <div class="add-method-div saved-method">
    <div class="header">Add Payment Method</div>
    <div class="input-flex add-payment-method-margin-bottom">
        <div class="add-card-button wd-50 card-detail" *ngIf="!isBankInfoShow"
        [hidden]="!paymentHubComponent?.defaultSettings?.settings.acceptCards" (click)="paymentHubComponent.adminUserWithKeypadEnabled() ? toggleKeypadShow(true) : toggleCardShow(true)">
            <img src="ui/assets/img/CreditDebit_Selection.svg" class="cc-ach-icons"/>
            <div>Credit or Debit Card</div>
        </div>
        <div class="add-card-button wd-50 account-detail" *ngIf="!isCardShow"
        [hidden]="!paymentHubComponent?.defaultSettings?.settings.acceptChecks" (click)=toggleBankInfoShow(true)>
            <img src="ui/assets/img/BankAccount_Selection.svg" class="cc-ach-icons"/>
            <div>Checking Account</div>
        </div>
    </div>
  </div>
</div>

<!-- edit-wallet-form -->
<div id="editWallet" *ngIf="isEditWalletShow" >
    <div class="wallet-edit-form-header">Edit Wallet</div>
    <form class="wallet-form-input" (ngSubmit)="onEditWalletSubmit()" #editForm="ngForm">
        <div id="wallet_nickname" >
          <label id="nickname_label" for="wallet_nickname">Payment Method Nickname:</label>
          <input 
          type="text"
          #editNicknameBox="ngModel" 
          [(ngModel)]="wallet.nickname" 
          name="Payment Method Name" 
          required>
        </div>

        <div *ngIf="editNicknameBox.invalid && (editNicknameBox.dirty || editNicknameBox.touched)"
                  class="invalid-feedback">
                  <div *ngIf="editNicknameBox.errors.required">Nickname is required</div>
        </div>
       
    <!-- Expiration Date Section Only for Credit/Debit Wallet Cards-->
        <div class="expiration-date-group" *ngIf="wallet.ccNumber != undefined">
          <label for="expirationMonth">Card Expiration:</label>
          <select id="expirationMonth" [(ngModel)]="expirationMonth" name="expirationMonth" required>
            <option *ngFor="let month of months" [value]="month">{{ month }}</option>
            </select>
          <label id="the-slash">/</label>
          <select id="expirationYear" [(ngModel)]="expirationYear" name="expirationYear" required>
            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
        </div>
       <div *ngIf="!isDateValid()" class="invalid-feedback">
            <div>Expiration must be a future date.</div>
          </div>
        <button type="submit" [disabled]="editForm.invalid || !isDateValid()">Save</button>
        <button type="reset" id="cancel-update" (click)="onEditWalletCancel()">Cancel</button>
      </form>
 </div>



<!-- card-form -->
<div id="DebitCard" *ngIf="isCardShow || isBankInfoShow">
    <div *ngIf="isCardShow" class="header">Enter Card Information</div>
    <div *ngIf="isCardShow" class="accepted-methods">
        <img  src="ui/assets/img/VISA.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/Mastercard.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/Discover.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/American Express.svg" class="accepted-methods-img"/>
    </div>
    <div *ngIf="isBankInfoShow"  class="header">Enter Bank Information</div>
    <div *ngIf="isBankInfoShow" class="accepted-methods">
     <img src="ui/assets/img/ACH.svg" class="accepted-methods-img"/>
    </div>
    <div class="clearfix"></div>
    <div class="card-detail-div">
        <form #formCard class="add-card">
            <div class="form-group type1">
                <div class="label" [hidden]="isBankInfoShow">Name on Card</div>
                <div class="label" [hidden]="isCardShow">Name on Bank Account</div>
                <div id="ccName" class="form-input">
                </div>
                <div *ngIf="cardErr.checkname.flag" class="invalid-feedback">
                    <div>{{cardErr.checkname.msg}}</div>
                </div>
            </div>
            <div [hidden]="isBankInfoShow" class="form-group">
                <div class="label">Card Number</div>
                <div id="ccNumber" class="form-input"></div>
                <div *ngIf="cardErr.ccnumber.flag" class="invalid-feedback">
                    <div>{{cardErr.ccnumber.msg}}</div>
                </div>
            </div>
            <div [hidden]="isCardShow" class="input-flex">
                <div [hidden]="isCardShow" class="form-group">
                    <div class="label">Routing Number</div>
                    <div id="routingNo" class="form-input"></div>
                    <div *ngIf="cardErr.checkaba.flag" class="invalid-feedback">
                        <div>{{cardErr.checkaba.msg}}</div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="label">Account Number</div>
                    <div id="acNumber" class="form-input"></div>
                    <div *ngIf="cardErr.checkaccount.flag" class="invalid-feedback">
                        <div>{{cardErr.checkaccount.msg}}</div>
                    </div>
                </div>
            </div>
            <div class="input-flex">
                <div [hidden]="isBankInfoShow" class="form-group">
                    <div class="label">Expiration Date</div>
                    <div id="ccExp" class="form-input"></div>
                    <div *ngIf="cardErr.ccexp.flag" class="invalid-feedback">
                        <div>{{cardErr.ccexp.msg}}</div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="label" [ngClass]="zipCode.invalid && zipCode.touched ? 'text-danger' : 'label control-label'">
                        ZIP Code
                    </div>
                    <div class="form-field-custom">
                        <input name="billing-postal" class="form-field-collect-js form-field" placeholder="00000"
                               minlength="5" maxlength="7" [(ngModel)]="wallet.zipCode" #zipCode="ngModel" required
                               [ngClass]="{'is-invalid': zipCode.invalid && zipCode.touched}" pattern="^(?! )[A-Za-z0-9 ]+(?<! )$"
                               [disabled]="isDisabled">
                    </div>
                    <div *ngIf="zipCode.invalid && zipCode.touched" class="invalid-feedback">
                        <div *ngIf="zipCode.errors?.required">ZIP Code is required</div>
                        <div *ngIf="zipCode.errors?.pattern">Invalid ZIP Code</div>
                        <div *ngIf="zipCode.errors?.minlength">Minimum length is 5 digits</div>
                        <div *ngIf="zipCode.errors?.maxlength">Maximum length is 7 digits</div>
                    </div>
                </div>
                <div [hidden]="isCardShow" class="form-group">
                    <div class="label">
                        Business Account
                    </div>
                    <div class="form-check form-check-inline">
                        <input name="businessAccount" id="achBusinessAcctYes" type="radio" [value]=true [(ngModel)]="achBusinessAccount">
                        <div class="input-group-append">
                            <span>Yes</span>
                        </div>
                    </div>
                    <div class="form-check form-check-inline">
                        <input name="businessAccount" id="achBusinessAcctNo" type="radio" [value]=false [(ngModel)]="achBusinessAccount">
                        <div class="input-group-append">
                            <span>No</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-flex">
                <div class="form-group bottom-m-br">
                    <div class="label" [ngClass]="nickname.invalid && nickname.touched ? 'text-danger' : 'label control-label'">
                        Payment Method Nickname
                    </div>
                    <div class="form-field-custom">
                        <input name="nickname" class="form-field-collect-js form-field" minlength="1" maxlength="20"
                               [(ngModel)]="wallet.nickname" #nickname="ngModel" placeholder="Nickname"
                               pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" required>
                    </div>
                    <div *ngIf="nickname.invalid && nickname.touched"
                         class="invalid-feedback" style="display: block">
                        <div *ngIf="nickname.errors?.required">Nickname is required</div>
                        <div *ngIf="nickname.errors?.pattern">Invalid Nickname</div>
                        <div *ngIf="nickname.errors?.minlength">Minimum length of 1 character</div>
                        <div *ngIf="nickname.errors?.maxlength">Maximum length of 20 characters</div>
                    </div>
                </div>         
            </div>
            <div class="sub-div">
                <div class="back-button" (click)=toggleCardShow(false);toggleBankInfoShow(false); >
                    <i class="fas fa-chevron-left"></i>
                </div>
                <button *ngIf="!onSubmitLoader" id="collectJsSubmissionTrigger" (click)=displayLoadingImage() class="btn submit-button" [disabled]="zipCode.invalid || nickname.invalid || (isCardShow && (cardErr.checkname.flag || cardErr.ccnumber.flag || cardErr.ccexp.flag)) || (isBankInfoShow && (cardErr.checkname.flag || cardErr.checkaba.flag || cardErr.checkaccount.flag))" type="submit">
                    Save to Wallet
                </button>
                <div class="btn submit-button" *ngIf="onSubmitLoader">
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- keypad form -->
<div id="keypadWallet" *ngIf="isKeypadShow">
    <div class="header">Enter Card Information</div>
    <div class="accepted-methods">
        <img src="ui/assets/img/VISA.svg" class="accepted-methods-img" />
        <img src="ui/assets/img/Mastercard.svg" class="accepted-methods-img" />
        <img src="ui/assets/img/Discover.svg" class="accepted-methods-img" />
        <img src="ui/assets/img/American Express.svg" class="accepted-methods-img"/>
    </div>
    <div class="clearfix"></div>
    <div class="card-detail-div">
        <form class="add-card">
            <div class="form-group">
                <div class="label" [ngClass]="keypadCardName.invalid && keypadCardName.touched ? 'text-danger' : 'label control-label'">
                    Name on Card
                </div>
                <div class="form-field-custom">
                    <input name="name-on-card" class="form-field-collect-js form-field" placeholder="Name on Card"
                           minlength="4" maxlength="100" [(ngModel)]="wallet.name" #keypadCardName="ngModel" required
                           pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" [ngClass]="{'is-invalid': keypadCardName.invalid && keypadCardName.touched}">
                </div>
                <div *ngIf="keypadCardName.invalid && keypadCardName.touched" class="invalid-feedback">
                    <div *ngIf="keypadCardName.errors?.pattern">Invalid Name on Card</div>
                    <div *ngIf="keypadCardName.errors?.minlength">Minimum length is 4 characters</div>
                    <div *ngIf="keypadCardName.errors?.maxlength">Maximum length is 100 characters</div>
                </div>
            </div>

            <div class="form-group">
                <div class="label" [ngClass]="keypadInput.invalid && keypadInput.touched ? 'text-danger' : 'label control-label'">
                    Keypad Input
                </div>
                <div [hidden]="keypadDataLocked">
                    <div class="form-field-custom">
                        <input name="keypad-data" class="form-field" type="password" minlength="160" maxlength="160"
                               [(ngModel)]="wallet.tokenId" #keypadInput="ngModel" required
                               [ngClass]="{'is-invalid': keypadInput.invalid && keypadInput.touched}"
                               (keydown.enter)="lockKeypadDataFieldIfInputValid()" placeholder="****************">
                    </div>
                    <div *ngIf="keypadInput.invalid && keypadInput.touched" class="invalid-feedback">
                        <div *ngIf="keypadInput.errors?.required">Keypad Input is required</div>
                        <div *ngIf="keypadInput.errors?.minlength">Invalid Keypad Input - Clear and Re-enter</div>
                        <div *ngIf="keypadInput.errors?.maxlength">Invalid Keypad Input - Clear and Re-enter</div>
                    </div>
                </div>
                <div [hidden]="!keypadDataLocked" class="success-text">
                    CAPTURED SUCCESSFULLY
                </div>
            </div>
            <div class="form-group">
                <div class="label" [ngClass]="keypadZipCode.invalid && keypadZipCode.touched ? 'text-danger' : 'label control-label'">
                    ZIP Code
                </div>
                <div class="form-field-custom">
                    <input name="billing-postal" class="form-field-collect-js form-field" placeholder="00000"
                           minlength="5" maxlength="7" [(ngModel)]="wallet.zipCode" #keypadZipCode="ngModel" required
                           [ngClass]="{'is-invalid': keypadZipCode.invalid && keypadZipCode.touched}"
                           pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" [disabled]="isDisabled">
                </div>
                <div *ngIf="keypadZipCode.invalid && keypadZipCode.touched"
                     class="invalid-feedback">
                    <div *ngIf="keypadZipCode.errors?.required">ZIP Code is required</div>
                    <div *ngIf="keypadZipCode.errors?.pattern">Invalid ZIP Code</div>
                    <div *ngIf="keypadZipCode.errors?.minlength">Minimum length is 5 digits</div>
                    <div *ngIf="keypadZipCode.errors?.maxlength">Maximum length is 7 digits</div>
                </div>
            </div>
            <div class="input-flex">
                <div class="form-group bottom-m-br">
                    <div class="label"
                         [ngClass]="keypadNickname.invalid && keypadNickname.touched ? 'text-danger' : 'label control-label'">
                        Payment Method Nickname
                    </div>
                    <div class="form-field-custom">
                        <input name="nickname" class="form-field-collect-js form-field" minlength="1" maxlength="20"
                               [(ngModel)]="wallet.nickname" #keypadNickname="ngModel" pattern="^(?! )[A-Za-z0-9 ]+(?<! )$"
                               placeholder="Nickname" required>
                    </div>
                    <div *ngIf="keypadNickname.invalid && keypadNickname.touched"
                         class="invalid-feedback" style="display: block">
                        <div *ngIf="keypadNickname.errors.required">Payment Method Nickname is required</div>
                        <div *ngIf="keypadNickname.errors?.pattern">Invalid Nickname</div>
                        <div *ngIf="keypadNickname.errors?.minlength">Minimum length of 1 character</div>
                        <div *ngIf="keypadNickname.errors?.maxlength">Maximum length of 20 characters</div>
                    </div>
                </div>
            </div>
            <div class="sub-div">
                <div class="back-button" (click)=toggleKeypadShow(false);>
                    <i class="fas fa-chevron-left"></i>
                </div>
                <button *ngIf="!onSubmitLoader" (click)="displayLoadingImage(); handleKeypadSubmission();" class="btn submit-button" [disabled]="keypadCardName.invalid || keypadInput.invalid || keypadZipCode.invalid || keypadNickname.invalid" type="submit">
                    Save to Wallet
                </button>
                <div class="btn submit-button" *ngIf="onSubmitLoader">
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                </div>
            </div>
        </form>
    </div>
</div>
